import * as React from "react";
import { useCallback, useMemo } from "react";
import IfPermitted from "components/common/IfPermitted";
import { LinkContainer } from "components/common";
import Button from "components/bootstrap/Button";
import usePluginEntities from "hooks/usePluginEntities";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import useLocation from "routing/useLocation";
import { getPathnameWithoutId } from "util/URLUtils";
const useEntityCreator = (entityKey) => {
  const entityCreators = usePluginEntities("entityCreators");
  const entityCreator = useMemo(
    () => entityCreators.find((creator) => creator.id === entityKey),
    [entityCreators, entityKey]
  );
  if (!entityCreator) {
    throw new Error(`Entity creator "${entityKey}" not found!`);
  }
  return entityCreator;
};
const CreateButton = ({ disabled = false, entityKey }) => {
  const entityCreator = useEntityCreator(entityKey);
  const sendTelemetry = useSendTelemetry();
  const { pathname } = useLocation();
  const _onClick = useCallback(() => {
    const { telemetryEvent } = entityCreator;
    if (telemetryEvent) {
      sendTelemetry(telemetryEvent.type, {
        app_pathname: getPathnameWithoutId(pathname),
        app_section: telemetryEvent.section,
        app_action_value: telemetryEvent.actionValue
      });
    }
  }, [entityCreator, pathname, sendTelemetry]);
  const PermissionWrapper = (entityCreator == null ? void 0 : entityCreator.permissions) ? ({ children }) => /* @__PURE__ */ React.createElement(IfPermitted, { permissions: entityCreator.permissions }, children) : React.Fragment;
  return /* @__PURE__ */ React.createElement(PermissionWrapper, null, /* @__PURE__ */ React.createElement(LinkContainer, { to: entityCreator.path }, /* @__PURE__ */ React.createElement(Button, { bsSize: "md", bsStyle: "primary", onClick: _onClick, disabled }, entityCreator.title)));
};
export default CreateButton;
